export default {
  'zh-CN': {
    personalInfoCollection: {
      title: '个人信息收集清单',
      updated: '最后更新：2025-08-07',
      intro: '为保障系统安全稳定运行并向您提供相应产品与服务，我们可能会收集以下个人信息：',
      headers: ['信息类型', '使用目的', '使用场景', '收集状态'],
      sections: [
        {
          title: '1. 个人资料',
          rows: [
            ['昵称', '账号创建与公开展示', '首次注册、设置昵称', '1 项'],
            ['手机号', '账号创建、登录认证', '账号创建、登录、找回密码验证', '1 项'],
            ['性别', '基于性别进行个性化内容推荐', '心情模块、内容推送', '已收集'],
            ['出生日期', '基于生日进行个性化内容推荐', '心情模块、内容推送', '已收集']
          ]
        },
        {
          title: '2. 设备信息',
          rows: [
            ['Android ID', '安全运行与风控', '应用内安全与风控', '已收集'],
            ['OAID', '安全运行与风控', '应用内安全与风控', '已收集'],
            ['设备型号与名称', '安全运行与风控', '应用内安全与风控、兼容性评估', '已收集'],
            ['设备厂商', '兼容性评估', '兼容性评估', '已收集'],
            ['语言设置', '安全运行与风控', '安全运行与风控', '已收集'],
            ['应用版本号', '安全运行与风控、兼容性评估', '应用内安全与风控、兼容性评估', '已收集'],
            ['系统剪贴板', '用户反馈', '用户反馈、复制官方邮箱地址', '一次性使用，不存储'],
            ['设备 GSM 网络类型', '安全运行与风险验证', '安全运行、风险验证与兼容性评估', '已收集'],
            ['IP 地址', '安全运行与风控', '安全运行与风控', '已收集']
          ]
        }
      ]
    }
  },
  en: {
    personalInfoCollection: {
      title: 'Personal Information Collection List',
      updated: 'Last updated: August 7, 2025',
      intro: 'To ensure secure and stable system operation and to provide related products and services, we may collect the following personal information from you:',
      headers: ['Information', 'Purpose', 'Usage Scenario', 'Collection Status'],
      sections: [
        {
          title: '1. Personal Profile',
          rows: [
            ['Nickname', 'Account creation and public display', 'First registration, setting nickname when creating account', '1 entry'],
            ['Phone number', 'Account creation, login authentication', 'Account creation, login, password reset verification', '1 entry'],
            ['Gender', 'Personalized content delivery based on gender', 'Mood module, content push', 'Collected'],
            ['Date of birth', 'Personalized content delivery based on birthday', 'Mood module, content push', 'Collected']
          ]
        },
        {
          title: '2. Device Information',
          rows: [
            ['Android ID', 'Secure operation and risk control', 'In-app security and risk control', 'Collected'],
            ['OAID', 'Secure operation and risk control', 'In-app security and risk control', 'Collected'],
            ['Device model and name', 'Secure operation and risk control', 'In-app security and risk control, compatibility assessment', 'Collected'],
            ['Device manufacturer', 'Compatibility assessment', 'Compatibility assessment', 'Collected'],
            ['Language settings', 'Secure operation and risk control', 'Secure operation and risk control', 'Collected'],
            ['App version number', 'Secure operation and risk control, compatibility assessment', 'In-app security and risk control, compatibility assessment', 'Collected'],
            ['System clipboard', 'User feedback', 'User feedback, copying official email address', 'One-time use, not stored'],
            ['Device GSM network type', 'Security operation and risk verification', 'Security operation, risk verification and compatibility assessment', 'Collected'],
            ['IP address', 'Secure operation and risk control', 'Secure operation and risk control', 'Collected']
          ]
        }
      ]
    }
  },
  ja: {
    personalInfoCollection: {
      title: '個人情報収集一覧',
      updated: '最終更新日：2025-08-07',
      intro: 'システムの安全かつ安定した運用と、関連する製品・サービスの提供のため、当社は以下の個人情報を収集する場合があります。',
      headers: ['情報', '目的', '利用場面', '収集状況'],
      sections: [
        {
          title: '1. 個人プロフィール',
          rows: [
            ['ニックネーム', 'アカウント作成と公開表示', '初回登録、アカウント作成時のニックネーム設定', '1 件'],
            ['電話番号', 'アカウント作成、ログイン認証', 'アカウント作成、ログイン、パスワード再設定認証', '1 件'],
            ['性別', '性別に応じたパーソナライズ配信', '気分モジュール、コンテンツ配信', '収集済み'],
            ['生年月日', '誕生日に応じたパーソナライズ配信', '気分モジュール、コンテンツ配信', '収集済み']
          ]
        },
        {
          title: '2. 端末情報',
          rows: [
            ['Android ID', '安全運用とリスク管理', 'アプリ内セキュリティとリスク管理', '収集済み'],
            ['OAID', '安全運用とリスク管理', 'アプリ内セキュリティとリスク管理', '収集済み'],
            ['端末モデルと名称', '安全運用とリスク管理', 'アプリ内セキュリティ、リスク管理、互換性評価', '収集済み'],
            ['端末メーカー', '互換性評価', '互換性評価', '収集済み'],
            ['言語設定', '安全運用とリスク管理', '安全運用とリスク管理', '収集済み'],
            ['アプリバージョン', '安全運用とリスク管理、互換性評価', 'アプリ内セキュリティ、リスク管理、互換性評価', '収集済み'],
            ['システムクリップボード', 'ユーザーフィードバック', 'ユーザーフィードバック、公式メールアドレスのコピー', '一時利用、保存なし'],
            ['端末 GSM ネットワーク種別', '安全運用とリスク検証', '安全運用、リスク検証、互換性評価', '収集済み'],
            ['IP アドレス', '安全運用とリスク管理', '安全運用とリスク管理', '収集済み']
          ]
        }
      ]
    }
  },
  'zh-TW': {
    personalInfoCollection: {
      title: '個人資訊蒐集清單',
      updated: '最後更新：2025-08-07',
      intro: '為確保系統安全穩定運行並提供相應產品與服務，我們可能會蒐集以下個人資訊：',
      headers: ['資訊類型', '使用目的', '使用情境', '蒐集狀態'],
      sections: [
        {
          title: '1. 個人資料',
          rows: [
            ['暱稱', '帳號建立與公開展示', '首次註冊、建立帳號時設定暱稱', '1 項'],
            ['手機號碼', '帳號建立、登入驗證', '帳號建立、登入、找回密碼驗證', '1 項'],
            ['性別', '依性別進行個人化內容推送', '心情模組、內容推送', '已蒐集'],
            ['出生日期', '依生日進行個人化內容推送', '心情模組、內容推送', '已蒐集']
          ]
        },
        {
          title: '2. 裝置資訊',
          rows: [
            ['Android ID', '安全運行與風控', '應用內安全與風控', '已蒐集'],
            ['OAID', '安全運行與風控', '應用內安全與風控', '已蒐集'],
            ['裝置型號與名稱', '安全運行與風控', '應用內安全與風控、相容性評估', '已蒐集'],
            ['裝置廠商', '相容性評估', '相容性評估', '已蒐集'],
            ['語言設定', '安全運行與風控', '安全運行與風控', '已蒐集'],
            ['應用版本號', '安全運行與風控、相容性評估', '應用內安全與風控、相容性評估', '已蒐集'],
            ['系統剪貼簿', '使用者回饋', '使用者回饋、複製官方信箱地址', '一次性使用，不儲存'],
            ['裝置 GSM 網路類型', '安全運行與風險驗證', '安全運行、風險驗證與相容性評估', '已蒐集'],
            ['IP 位址', '安全運行與風控', '安全運行與風控', '已蒐集']
          ]
        }
      ]
    }
  }
}
